import React from 'react';
import { Box, Paper, Typography, CircularProgress, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { INDIA_GOLD_IMPORT_DUTY } from '../utils/goldPrice';

const formatINR = (value, digits = 0) =>
  new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(value);

const LiveGoldPriceCard = ({ goldPrice, loading, error }) => (
  <Paper
    sx={{
      mb: 3,
      p: 2,
      borderRadius: 3,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      gap: 2,
      boxShadow: 'var(--fx-card-shadow)',
    }}
  >
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <Typography variant="body2" color="text.secondary">
          Live Gold Price India (24K)
        </Typography>
        <Tooltip title={`COMEX gold × USD/INR + ${INDIA_GOLD_IMPORT_DUTY * 100}% import duty. Excludes 3% GST, like published Indian rates; local dealer rates may differ slightly.`}>
          <InfoOutlinedIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
        </Tooltip>
      </Box>
      {loading && !goldPrice ? (
        <CircularProgress size={20} sx={{ mt: 1 }} />
      ) : goldPrice ? (
        <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
          <Typography variant="h5" sx={{ fontWeight: 600 }}>
            {formatINR(goldPrice.pricePerGram * 10)}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            / 10g · {formatINR(goldPrice.pricePerGram, 2)}/g
          </Typography>
          {goldPrice.changePercent !== null && (
            <Typography
              variant="body2"
              sx={{ fontWeight: 600, color: goldPrice.changePercent >= 0 ? 'success.main' : 'error.main' }}
            >
              {goldPrice.changePercent >= 0 ? '+' : ''}
              {goldPrice.changePercent.toFixed(2)}%
            </Typography>
          )}
        </Box>
      ) : (
        <Typography variant="body2" color="error.main" sx={{ mt: 1 }}>
          {error || 'Live price unavailable'}
        </Typography>
      )}
    </Box>
    {goldPrice && (
      <Typography variant="caption" color="text.secondary" sx={{ textAlign: 'right' }}>
        ${goldPrice.usdPerOunce.toFixed(2)}/oz · ₹{goldPrice.usdInr.toFixed(2)}/USD · Intl {formatINR(goldPrice.internationalPerGram * 10)}/10g
        <br />
        Updated {goldPrice.asOf.toLocaleString('en-IN')}
      </Typography>
    )}
  </Paper>
);

export default LiveGoldPriceCard;
